import React from 'react'
import { useHistory } from 'react-router-dom'
import { formatFullDate, getAssessmentCurrentData } from '../../utils/date'
import { openLinkInTab } from '../../utils/openLinkInTab'

// Sized for the 72px round thumbnail at 2x DPR.
const REMAINING_PAYMENT_IMAGE = `${process.env.REACT_APP_IMG_SOURCE}/5ffe9e5be7dd4a143eaba9d4.jpg?fit=crop&crop=edges&w=144&h=144&auto=format`

const QuestImportantItems = ({
  questId,
  questTitle,
  orientationCall,
  questSteps,
}) => {
  const history = useHistory()

  const handleOrientationCallClick = () => {
    if (!orientationCall?.link) return

    openLinkInTab(orientationCall.link, '_blank')
  }

  // Deposit paid but the balance is still outstanding, so surface the payment
  // card at the top of the list until it is settled.
  const questPayments = questSteps?.questPayments || {}
  const { canPayRemaining, remainingBalance, remainingPaymentDate } =
    questPayments
  // Sent alongside questPayments rather than inside it
  const isAutoPayEnabled = !!(
    questPayments.isAutoPayEnabled || questSteps?.isAutoPayEnabled
  )
  const pendingBalance = Number(remainingBalance) || 0
  const hasRemainingPayment = !!canPayRemaining && pendingBalance > 0
  // Auto-pay means the card on file gets charged on that date, so word it as a
  // heads-up rather than as something the user still has to action.
  const paymentDateNote = remainingPaymentDate
    ? ` | ${
        isAutoPayEnabled ? 'Payment will be charged automatically on' : 'Due on'
      } ${formatFullDate(remainingPaymentDate)}`
    : ''
  const remainingPaymentDetail = `Pay Now - $${pendingBalance.toLocaleString()}${paymentDateNote}`

  const tasks = [
    ...(hasRemainingPayment
      ? [
          {
            title: 'Complete Remaining Payment',
            detail: remainingPaymentDetail,
            imageSrc: REMAINING_PAYMENT_IMAGE,
            onClick: () =>
              history.push(`/your-experiences/${questId}/payments`),
          },
        ]
      : []),
    {
      title: 'Upload Air Tickets and Travel Insurance',
      detail: 'Upload Now',
      imageSrc: '/assets/quest-important-items/upload-travel-documents.webp',
      onClick: () =>
        history.push(`/your-experiences/${questId}/travel-documents`),
    },
    {
      title: 'Review Packing List',
      detail: 'Review Now',
      imageSrc: '/assets/quest-important-items/review-travel-checklist.webp',
      onClick: () => history.push(`/your-experiences/${questId}/todos`),
    },
    {
      title: 'Review Itinerary',
      detail: 'Review Now',
      imageSrc: '/assets/quest-important-items/review-itinerary.webp',
      onClick: () => history.push(`/your-experiences/${questId}/itinrary`),
    },
    {
      title: 'Attend Orientation',
      detail: orientationCall?.date
        ? getAssessmentCurrentData(orientationCall.date, 'MMMM Do, YYYY')
        : 'Orientation date will be announced',
      imageSrc: '/assets/quest-important-items/attend-orientation.webp',
      onClick: orientationCall?.link ? handleOrientationCallClick : undefined,
    },
  ]

  return (
    <section className='quest-dashboard-section'>
      <h3 className='s3 mb-0'>Important Items</h3>
      <div className='quest-important-items-list'>
        {tasks.map((task, index) => (
          <button
            key={index}
            type='button'
            className={`quest-important-item-card${
              task.onClick ? '' : ' quest-important-item-card-inactive'
            }`}
            onClick={task.onClick}>
            <img
              className='quest-important-item-image'
              src={task.imageSrc}
              alt={task.title}
              width='66'
              height='66'
              loading='lazy'
              decoding='async'
            />
            <div className='quest-important-item-copy text-start'>
              <div className='quest-important-item-title'>{task.title}</div>
              <div className='quest-important-item-detail'>{task.detail}</div>
            </div>
            {task.onClick ? (
              <span className='icon icon-right-arrow color-right-arrow s9 quest-important-item-arrow' />
            ) : (
              <span
                className='icon icon-right-arrow s9 quest-important-item-arrow quest-important-item-arrow-disabled'
                title='Link not available yet'
              />
            )}
          </button>
        ))}
      </div>
    </section>
  )
}

export default QuestImportantItems
